import { Dispatch } from "react"
import { useSelector } from "react-redux"
import { IStore } from "../../../../../../../core/store"
import { ShowConfigurationPivot } from "../../../common/pivots/ShowConfigurationPivot"
import { TIdentificationModuleSettingsPivotStates } from "../../IdentificationModule"
import { GlobalCommonSettingsPivot } from "./GlobalCommonSettingsPivot"
import { GlobalUISettingsPivot } from "./GlobalUISettingsPivot"

type TProps = {
    state: TIdentificationModuleSettingsPivotStates
    index: number
    onChangeDispatch: Dispatch<any>
    okButtonDisabled(arg: boolean): void
}

export const GlobalSettingsPivotBasedState: React.FC<TProps> = (props) => {
    switch (props.state) {
        case "ui": return (
            <GlobalUISettingsPivot index={props.index} onChangeDispatch={props.onChangeDispatch} />
        )
        case "common": return (
            <GlobalCommonSettingsPivot index={props.index} onChangeDispatch={props.onChangeDispatch} okButtonDisabled={props.okButtonDisabled} />
        )
        case "config": return (
            <ShowConfigurationPivot json={useSelector((s: IStore) => s.configurator.identification.items.find(i => i.index === props.index)) ?? {}} />
        )
        default:
            return (
                <></>
            )
    }
}
